import React, { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FaUser, FaSignOutAlt, FaTachometerAlt } from "react-icons/fa";
import app from "../utils/firebase";
import '../styling/Profile.css';

const Profile = () => {
    const [isAuthenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const auth = getAuth(app);

    onAuthStateChanged(auth, (u) => {
        if (u) {
            setAuthenticated(true);
            setUser(u);
            setLoading(false);
        } else {
            setAuthenticated(false);
            setLoading(false);
        }
    });

    const logout = () => {
        auth.signOut().catch((error) => console.log(error));
    };

    const getInitials = (u) => {
        if (u.displayName) {
            return u.displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
        }
        return u.email ? u.email[0].toUpperCase() : '?';
    };

    return (
        <>
        {loading && <div className="profile-loading" />}
        {isAuthenticated && user && (
            <div className="profile-page">
                <div className="profile-card">
                    <div className="profile-avatar-wrap">
                        {user.photoURL ? (
                            <img src={user.photoURL} alt="Profile" className="profile-pic" />
                        ) : (
                            <div className="profile-initials">
                                {getInitials(user)}
                            </div>
                        )}
                    </div>

                    <div className="profile-info">
                        {user.displayName && (
                            <h2 className="profile-name">{user.displayName}</h2>
                        )}
                        <p className="profile-email">{user.email}</p>
                    </div>

                    <div className="profile-divider" />

                    <div className="profile-actions">
                        <Link to="/dashboard" className="profile-btn-primary">
                            <FaTachometerAlt size={14} /> Go to Dashboard
                        </Link>
                        <button onClick={logout} className="profile-btn-ghost">
                            <FaSignOutAlt size={14} /> Sign Out
                        </button>
                    </div>
                </div>
            </div>
        )}
        {!isAuthenticated && !loading && <Navigate to="/login" />}
        </>
    );
};

export default Profile;
